module.exports = __webpack_public_path__ + "static/media/mic-on.e74d3c4c.svg";